module.exports = __webpack_public_path__ + "img/logo.8ed25d8c.png";